var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { AppBar as MuiAppBar, Toolbar, Typography, Avatar, Divider, Button, Menu, MenuItem } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { useAuth0 } from '@cmr/react-auth0';
import { CmrLogo } from './cmr-logo';
import { SearchBox } from './search-box';
var useStyles = function (color) {
    var _a = useTheme(), zIndex = _a.zIndex, spacing = _a.spacing;
    return makeStyles({
        appBar: {
            zIndex: zIndex.drawer + 1,
            backgroundColor: color,
            color: 'white'
        },
        logo: {
            height: '30px'
        },
        grow: {
            flexGrow: 1
        },
        logoLink: {
            textDecoration: 'none',
            color: 'white',
            display: 'flex',
            alignItems: 'center'
        },
        logoText: {
            fontWeight: 100,
            marginLeft: spacing(),
            marginRight: spacing()
        },
        logoDivider: {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            marginLeft: spacing(),
            marginTop: spacing(0.5),
            marginBottom: spacing(0.5)
        },
        logoIcon: {
            color: 'rgba(255, 255, 255, 0.5)'
        }
    })();
};
export var AppBar = function (_a) {
    var appName = _a.appName, showSearchBox = _a.showSearchBox, children = _a.children, color = _a.color, position = _a.position, searchBoxProps = _a.searchBoxProps;
    var classes = useStyles(color || '#333333');
    var _b = useAuth0(), user = _b.user, logout = _b.logout;
    var _c = React.useState(null), userMenuAnchor = _c[0], setUserMenuAnchor = _c[1];
    var logoutClick = React.useCallback(function () {
        setUserMenuAnchor(null);
        logout();
    }, [logout]);
    return (React.createElement(MuiAppBar, { position: position || 'static', className: classes.appBar },
        React.createElement(Toolbar, { variant: 'dense' },
            React.createElement(NavLink, { to: '/', className: classes.logoLink },
                React.createElement(CmrLogo, { className: classes.logo }),
                ' ',
                React.createElement(Divider, { orientation: 'vertical', flexItem: true, className: classes.logoDivider }),
                React.createElement(Typography, { variant: 'h4', display: 'inline', className: classes.logoText }, appName)),
            React.createElement("div", { className: classes.grow }),
            showSearchBox && React.createElement(SearchBox, __assign({}, searchBoxProps)),
            " \u00A0",
            children,
            React.createElement(Button, { color: 'inherit', onClick: function (e) { return setUserMenuAnchor(e.currentTarget); } },
                React.createElement(Avatar, { src: user.picture })),
            React.createElement(Menu, { id: 'menu-appbar', anchorEl: userMenuAnchor, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }, open: Boolean(userMenuAnchor), onClose: function () { return setUserMenuAnchor(null); } },
                React.createElement(MenuItem, { onClick: logoutClick }, "Logout")))));
};
//# sourceMappingURL=app-bar.js.map